import styles from './Grid.module.css'
import { Grid as GridMui } from '@mui/material';

export function Col(props) {
  return (
    <GridMui size={props.size ? props.size : 12} {...props}>
      <div className={styles.field_column}>{props.children}</div>
    </GridMui>
  )
}
export function Grid(props) {
  return <GridMui container spacing={2} marginBottom={"5px"} {...props}>{props.children}</GridMui>
}
